// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyC7TkG_rDD5yZeilIPEA0NztYeuogLr_Tw",
  authDomain: "zota-pricing-tool.firebaseapp.com",
  databaseURL: "https://zota-pricing-tool.firebaseio.com",
  projectId: "zota-pricing-tool",
  storageBucket: "zota-pricing-tool.appspot.com",
  messagingSenderId: "325898242167",
  appId: "1:325898242167:web:adcf7fe5c320205fbf5e72",
  measurementId: "G-CJSTQHNTS3"
};